import { t } from "i18next";
import React, { useState } from "react";
import { Button, Modal } from "react-bootstrap";
// import { toast } from "react-toastify";
import { useNavigate } from "react-router-dom";

// Utility to detect Dropbox folder link
const isDropboxFolder = (url = "") => url.includes("/fo/");

export default function VideoList({
  setCurrentVideo,
  videoList = [],
  currentVideo,
  onSave,
  onReset,
}) {
  const [show, setShow] = useState(false);
  const [video, setVideo] = useState("");

  const navigate = useNavigate();

  const handleModalClose = () => {
    setShow(false);
  };

  const resetModalHandler = (data) => {
    setVideo(data);
    setShow(true);
  };

  const resetHandler = () => {
    onReset(video);
    setShow(false);
  };

 const selectVideo = (video) => {
  if (video.isFolder) {
    navigate(`/folder-view/${video.id}`, {
      state: {
        folderUrl: video.videoUrl,
        title: video.title,
      },
    });
  } else {
    setCurrentVideo(video);
  }
};


  // Enhance the video list with isFolder property
  const processedList = videoList.map((video) => ({
    ...video,
    isFolder: isDropboxFolder(video.videoUrl),
  }));

  return (
    <>
      {processedList && (
        <>
          <div>
            {processedList.map((video) => (
              <div className="row" key={video.id}>
                <div
                  className={`video-item-container ${
                    video.isFolder ? "folder-item" : ""
                  }`}
                  onClick={() => selectVideo(video)}
                  style={{ cursor:  "pointer" }}
                >
                  <div
                    className={`video-list-item${
                      currentVideo?.id === video?.id
                        ? "-selected"
                        : !video.userViewed && video?.isLocked
                        ? "-locked"
                        : ""
                    }`}
                  >
                    <div className="col-md-8">
                      {video.isFolder ? (
                        <>
                          <i
                            className="fa-solid fa-folder-open me-2"
                            style={{ color: "#f1c40f" }}
                          ></i>
                          <strong>{video.title}</strong>
                        </>
                      ) : (
                        video.title
                      )}
                    </div>

                    <div className="col-md-4">
                      <div className="video-list-icons">
                        {video.isFolder ? (
                          <i
                            className="fa-solid fa-folder-tree fa-lg control-icons"
                            style={{ color: "#666" }}
                          ></i>
                        ) : currentVideo?.id === video?.id ? (
                          <>
                            <i
                              className="fa-solid fa-rotate-left fa-lg control-icons"
                              onClick={() =>
                                resetModalHandler({
                                  videoId: video?.id,
                                  historyId:
                                    video?.userViewed?.id ??
                                    currentVideo?.userViewed?.id,
                                })
                              }
                            ></i>
                            {video?.userViewed?.testPassed ? (
                              <i className="fa-solid fa-circle-check fa-lg control-icons"></i>
                            ) : (
                              <i className="fa-solid fa-clock fa-lg"></i>
                            )}
                          </>
                        ) : video.userViewed || !video.isLocked ? (
                          video?.userViewed?.testPassed ? (
                            <i
                              className="fa-solid fa-circle-check fa-lg control-icons"
                              style={{ color: "#4e9a06" }}
                            ></i>
                          ) : (
                            <i className="fa-regular fa-clock fa-lg control-icons"></i>
                          )
                        ) : (
                          <i className="fa-solid fa-lock fa-lg control-icons"></i>
                        )}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            ))}
          </div>

          <Modal show={show} onHide={handleModalClose}>
            <Modal.Header>
              <h5>{t("reset_progress")} ?</h5>
            </Modal.Header>
            <Modal.Body>
              <p>{t("reset_confirm")}</p>
            </Modal.Body>
            <Modal.Footer>
              <Button variant="primary" onClick={handleModalClose}>
                {t("cancel")}
              </Button>
              <Button variant="danger" onClick={resetHandler}>
                {t("reset")}
              </Button>
            </Modal.Footer>
          </Modal>
        </>
      )}
    </>
  );
}
